export function ScrollToTop () {
    setTimeout(() => {
        window.scrollTo(0,0);
        document.documentElement.scrollTop = 0;
        document.body.scrollTo = 0;
    }, 100)
}